import React, { useState } from "react";

const ImageHandler = ({
  mediaElement,
  setMediaElement,
  disable,
  imagesCount,
}) => {
  const [previewImage, setPreviewImage] = useState(null);

  // Function to remove an image
  const handleRemoveImage = (index) => {
    const updatedImages = [...(mediaElement?.MEDIA || [])];
    updatedImages.splice(index, 1);

    // Ensure correct state update for `campusElement`
    setMediaElement(updatedImages);
  };

  return (
    <div className="w-full">
      <div className="grid grid-cols-3 gap-4">
        {Array.from({ length: imagesCount || 5 }).map((_, index) => (
          <div
            key={index}
            className="relative group border border-gray-200 rounded-lg overflow-hidden transition-all duration-300 hover:shadow-md"
          >
            {mediaElement?.MEDIA?.[index]?.image_url ||
            mediaElement?.MEDIA?.[index]?.orignalImage ? (
              <>
                <div className="aspect-square relative">
                  <img
                    src={
                      mediaElement?.MEDIA?.[index]?.image_url ||
                      mediaElement?.MEDIA?.[index]?.orignalImage
                    }
                    alt={`Uploaded image ${index + 1}`}
                    className="w-full h-full object-cover cursor-pointer"
                    onClick={() => {
                      console.log(
                        "Previewing:",
                        mediaElement?.MEDIA?.[index]?.image_url ||
                          mediaElement?.MEDIA?.[index]?.orignalImage
                      );
                      setPreviewImage(
                        mediaElement?.MEDIA?.[index]?.image_url ||
                          mediaElement?.MEDIA?.[index]?.orignalImage
                      );
                    }}
                  />

                  {/* Remove Button */}
                  {!disable && (
                    <button
                      className="absolute top-2 right-2 bg-red-500 text-white w-6 h-6 flex items-center justify-center rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300 hover:bg-red-600"
                      onClick={() => handleRemoveImage(index)}
                      aria-label="Remove image"
                    >
                      ✕
                    </button>
                  )}
                </div>
              </>
            ) : (
              <div className="aspect-square bg-gray-200 flex items-center justify-center">
                <span className="text-gray-500">No Image</span>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Preview Modal */}
      {previewImage && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-70"
          onClick={() => setPreviewImage(null)}
        >
          <div
            className="relative bg-white p-4 rounded-lg shadow-2xl max-w-4xl w-full max-h-[90vh] flex items-center justify-center"
            onClick={(e) => e.stopPropagation()}
          >
            {!disable && (
              <button
                className="absolute top-4 right-4 bg-red-500 text-white w-8 h-8 flex items-center justify-center rounded-full hover:bg-red-600 transition-colors"
                onClick={() => setPreviewImage(null)}
                aria-label="Close preview"
              >
                ✕
              </button>
            )}
            <img
              src={previewImage}
              alt="Full preview"
              className="max-w-full max-h-[80vh] object-contain rounded-lg"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default ImageHandler;
